<template>
  <div v-if="!item.hidden && item.children && item.children.length > 0">
    <el-submenu v-if="item.isChildren" :index="item.path">
      <template slot="title">
        <item :icon="item.meta ? item.meta.icon : ''" :title="item.meta ? item.meta.title : ''" />
      </template>
      <div v-for="(subItem, subIndex) in item.children" :key="subIndex">
        <app-link v-if="subItem.meta && !subItem.hidden" :to="item.path + '/' + subItem.path">
          <el-menu-item :index="item.path + '/' + subItem.path">{{ subItem.meta ? subItem.meta.title : '' }}</el-menu-item>
        </app-link>
      </div>
    </el-submenu>

    <app-link v-else :to="item.path + '/' + item.children[0].path ">
      <el-menu-item :index="item.path + '/' + item.children[0].path">

        <item :icon="item.meta ? item.meta.icon : ''" :title="item.meta ? item.meta.title : ''" />

      </el-menu-item>
    </app-link>
  </div>
</template>

<script>
import Item from './Item'
import AppLink from './Link'
import FixiOSBug from './FixiOSBug'

export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-submenu {
  .el-menu--inline {
    background-color: rgba(0, 0, 0, 1) !important;
  }
  .el-submenu__title i {
    margin-right: 5px;
  }
}
</style>
